import React, { useMemo } from 'react';
import FiltersGroupContainer from './FiltersGroupContainer';
import TagsSelector from '../../TagsSelector';

import '../styles/_tagsFilters.scss';











export default function TagsFiltersGroup({
  label = 'Tags',
  isCollapsible,
  openedByDefault,
  minWidth,
  filterFacets,
  selectedValues = [],
  onChange
}) {
  const selectedTags = useMemo(() =>
  selectedValues.map(
    (value) =>
    filterFacets.find(
      ({ tagId }) => tagId === value
    )

  ),
  [selectedValues]);

  const onChangeTagSelection = (selectedTagItems) => {
    onChange(selectedTagItems.map(({ tagId }) => tagId));
  };

  return (
    <FiltersGroupContainer
      label={label}
      isCollapsible={isCollapsible}
      openedByDefault={openedByDefault}
      minWidth={minWidth}>

      <TagsSelector
        className="tags-filters"
        selectedTags={selectedTags}
        tagsList={filterFacets}
        onChange={onChangeTagSelection}
        isClearable
        renderMenuLocally />

    </FiltersGroupContainer>);

}